import React, { useContext } from 'react';
import { ConfigContext } from '.';
import Empty from "../empty";
import { jsx as _jsx } from "react/jsx-runtime";
/* refer to: https://github.com/ant-design/ant-design/blob/master/components/config-provider/defaultRenderEmpty.tsx */
var DefaultRenderEmpty = function DefaultRenderEmpty(props) {
  var componentName = props.componentName;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefix = getPrefixCls('empty');
  switch (componentName) {
    case 'Select':
    case 'TreeSelect':
    case 'Cascader':
    case 'Transfer':
    case 'Mentions':
      return /*#__PURE__*/_jsx(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        className: "".concat(prefix, "-small")
      });
    default:
      return /*#__PURE__*/_jsx(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE
      });
  }
};
export default DefaultRenderEmpty;